
import { i18nText } from '@/locales';
import moment from "moment";
import {transferForm} from "./SalonTypes";
import { phone, fio, maxDigits, checkSpaces } from "@/utils/validators/rules";

export class SalonForm {
    id: number | null;
    company_id: number | null;
    active: number | null;
    salon_name: string;
    city_id: number | null;
    partner_name: string;
    partner_phone: string;
    partner_email: string;
    partner_social_network: string;
    opening_date: string;
    work_time_from: string;
    work_time_to: string;
    phone: string;
    address: string;
    social_network_link: string;
    escort_manager_id: number | null;
    salon_group_id: number | null;
    conclusion_contract_date: string;
    currency_id: number | null;
    legal_entity_name: string;
    name: string;
    legal_address: string;
    legal_entity_data_INN: number | null;
    legal_entity_data_KPP: number | null;
    account_RCBIC: number | null;
    bank_name: string;
    correspondent_account: number | null;
    checking_account: string;
    transfer: transferForm

    partner_id: number | null
    legal_entity_id: number | null

    constructor() {
        this.id = null;
        this.company_id = null;
        this.active = 1;
        this.salon_name = "";
        this.city_id = null;
        this.name = "";
        this.phone = "";
        this.partner_name = "";
        this.partner_phone = "";
        this.partner_email = "";
        this.partner_social_network = "";
        this.legal_entity_name = "";
        this.legal_address = "";
        this.legal_entity_data_INN = null;
        this.legal_entity_data_KPP = null;
        this.account_RCBIC = null;
        this.bank_name = "";
        this.correspondent_account = null;
        this.checking_account = "";
        this.opening_date = moment().format('DD.MM.YYYY');
        this.work_time_from = moment('09:00', 'HH:mm') as any;
        this.work_time_to = moment('21:00', 'HH:mm') as any;
        this.address = "";
        this.social_network_link = "";
        this.escort_manager_id = null;
        this.salon_group_id = null;
        this.conclusion_contract_date = "";
        this.currency_id = null;
        this.legal_entity_name = "";
        this.transfer = {
            salon_id: null,
            services: {
                all: '',
                category: [],
                id: []
            },
            products: {
                all: '',
                category: [],
                id: []
            },
            loyalty: {
                all: '',
                category: [],
                id: []
            }
        }

        this.partner_id = null
        this.legal_entity_id = null
    }

    setFormData(data: any) {
// console.error(data)
        this.id = data.id
        this.company_id = data.company_id
        this.salon_name = data.name
        this.city_id = data.city && data.city.id
        this.address = data.address
        this.opening_date = data.opening_date
        this.social_network_link = data.social_network_link
        this.active = data.active ? 1 : 0;
        this.currency_id = data.currency_id
        this.phone = data.phone
        this.work_time_to = moment(data.work_time_to, 'HH:mm') as any
        this.work_time_from = moment(data.work_time_from, 'HH:mm') as any
        this.escort_manager_id = /*data.manager && data.manager.id && */data.escort_manager_id
        this.salon_group_id = data.salon_group_id
        this.partner_name = data.partner && data.partner.name
        this.partner_email = data.partner && data.partner.email
        this.partner_phone = data.partner && data.partner.phone
        this.partner_social_network = data.partner && data.partner.social_network
        this.conclusion_contract_date = data.conclusion_contract_date ? moment(data.conclusion_contract_date, 'DD.MM.YYYY') as any : ''
        this.legal_entity_name = data.legal_entity_data && data.legal_entity_data.name
        this.legal_address = data.legal_entity_data && data.legal_entity_data.legal_address
        this.legal_entity_data_INN = data.legal_entity_data && data.legal_entity_data.legal_entity_data_INN
        this.legal_entity_data_KPP = data.legal_entity_data && data.legal_entity_data.legal_entity_data_KPP
        this.account_RCBIC = data.legal_entity_data && data.legal_entity_data.account && data.legal_entity_data.account.account_RCBIC
        this.bank_name = data.legal_entity_data && data.legal_entity_data.account && data.legal_entity_data.account.bank_name
        this.correspondent_account = data.legal_entity_data && data.legal_entity_data.account && data.legal_entity_data.account.correspondent_account
        this.checking_account = data.legal_entity_data && data.legal_entity_data.account && data.legal_entity_data.account.checking_account

        this.legal_entity_id = data.legal_entity_data && data.legal_entity_data.id
        this.partner_id = data.partner && data.partner.id
    }
}

export const FormRules = {
    active: [{required: true, type: 'number', message: i18nText("Укажите активность"), trigger: "change"}],
    salon_name: [{required: true, message: i18nText("Введите наименование студии"), trigger: "change"},
        {validator: checkSpaces, message: i18nText("Поле не может состоять исключительно из пробелов"), trigger: "change"}],
    phone: [{validator: (field: any, value: string) => !value || phone(field, value), message: i18nText("Введите номер телефона студии"), trigger: "change"}],
    partner_email: [{type: 'email', message: i18nText("Введите корректный email партнера"), trigger: "change"}],
}

export const FormGroupRules = {
    name: [{required: true, message: i18nText("Укажите наименование группы"), trigger: "change"}],
}
